import { createClient } from '@supabase/supabase-js'

// Configuración con fallback para producción
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ecklqizrevtvpvwtrsmk.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVja2xxaXpyZXZ0dnB2d3Ryc21rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAyNzAxNDksImV4cCI6MjA3NTg0NjE0OX0.9ybgICYScBbWyAeVkHQwph6VMOSDZW22Muv1gpLN5zg'

// Debug: verificar variables de entorno
console.log('🌍 Environment:', process.env.NODE_ENV)
console.log('🔧 Supabase URL:', supabaseUrl ? '✅ Disponible' : '❌ No encontrada')
console.log('🔧 Supabase Key:', supabaseAnonKey ? '✅ Disponible' : '❌ No encontrada')
console.log('🔗 Using URL:', supabaseUrl)

let supabase = null
let supabaseError = null

try {
  supabase = createClient(supabaseUrl, supabaseAnonKey)
  console.log('✅ Supabase client initialized successfully')
} catch (error) {
  console.error('❌ Error initializing Supabase:', error)
  supabaseError = error
}

export { supabase, supabaseError }